module.exports = __webpack_public_path__ + "img/QY_5.77c49813.png";